import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const Footer = () => (
  <footer className="relative border-t border-[#262B3D] bg-[#0A0C10] grain overflow-hidden">
    <div className="container-site py-16 sm:py-24">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10">
        <div className="max-w-xl">
          <p className="eyebrow mb-4">Le prochain palier</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.1]">
            Ta trajectoire ne changera pas toute seule.{" "}
            <span className="text-primary text-glow">Fais la bascule.</span>
          </h2>
        </div>
        <div className="flex flex-col sm:flex-row gap-4">
          <Link
            to="/offre#postuler"
            data-testid="footer-cta-apply"
            className="group inline-flex items-center justify-center gap-2 bg-primary text-[#0A0C10] font-semibold px-7 py-4 rounded-full transition-all duration-300 hover:bg-[#00C885] hover:shadow-[0_0_40px_rgba(0,229,153,0.4)]"
          >
            Booker mon Check Up
            <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
          <Link
            to="/newsletter"
            data-testid="footer-cta-newsletter"
            className="inline-flex items-center justify-center gap-2 border border-[#262B3D] text-slate-200 font-semibold px-7 py-4 rounded-full transition-all duration-300 hover:border-primary hover:text-primary"
          >
            Rejoindre la newsletter
          </Link>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-[#262B3D] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div className="flex items-center gap-2">
          <img src="/logo-icon.png" alt="La Bascule" className="w-7 h-7 rounded-lg" />
          <span className="font-heading font-bold">La Bascule</span>
        </div>
        <nav className="flex flex-wrap gap-x-8 gap-y-2 text-sm text-slate-400">
          <Link to="/newsletter" data-testid="footer-link-newsletter" className="hover:text-primary transition-colors">Newsletter</Link>
          <Link to="/offre" data-testid="footer-link-offre" className="hover:text-primary transition-colors">Accompagnement</Link>
          <Link to="/a-propos" data-testid="footer-link-about" className="hover:text-primary transition-colors">À propos</Link>
          <Link to="/mentions-legales" data-testid="footer-link-legal" className="hover:text-primary transition-colors">Mentions légales</Link>
        </nav>
        <div className="flex items-center gap-2 text-xs text-slate-500 font-mono">
          <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
          © 2026 La Bascule
        </div>
      </div>
    </div>
  </footer>
);
